import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig.ts";

export const msalInstance = new PublicClientApplication(msalConfig);
